import React, { useEffect } from 'react';
import { StatusBar, ErrorUtils } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import AsyncStorage from '@react-native-async-storage/async-storage';
import AppNavigator from './src/navigation/AppNavigator';
import { useUserStore } from './src/store';
import { PROFILE_KEY } from './src/screens/auth/OnboardingScreen';
// Register background location task before anything else uses it
import './src/tasks/locationTask';
import { appLog } from './src/utils/logger';

// Catch uncaught JS errors and write them to the log before the default handler
if (ErrorUtils && typeof ErrorUtils.getGlobalHandler === 'function') {
  const _defaultErrorHandler = ErrorUtils.getGlobalHandler();
  ErrorUtils.setGlobalHandler((error: Error, isFatal?: boolean) => {
    appLog.error(`[CRASH${isFatal ? ' FATAL' : ''}] ${error?.message ?? 'Unknown error'}`, {
      stack: error?.stack,
      isFatal,
    });
    _defaultErrorHandler(error, isFatal);
  });
}

function App() {
  const setProfile = useUserStore((s) => s.setProfile);

  // Restore saved profile on cold start
  useEffect(() => {
    (async () => {
      // Load persisted logs first so crash logs from previous session are visible
      await appLog.loadFromStorage();
      appLog.info('App mounted');
      try {
        const raw = await AsyncStorage.getItem(PROFILE_KEY);
        if (raw) setProfile(JSON.parse(raw));
      } catch {
        // No saved profile — stay on onboarding
      }
    })();
  }, []);

  return (
    <SafeAreaProvider style={{ flex: 1 }}>
      <StatusBar barStyle="dark-content" />
      <AppNavigator />
    </SafeAreaProvider>
  );
}

export default App;
